import SmoothScroll from 'smooth-scroll';
export class PageAncher {

    constructor() {
        this.triggers = {};
        this.body = {};
    }

    init() {
        this.body = document.getElementsByTagName('body')[0];

        // vanilla JS smoooth scroll
        this.links = document.querySelectorAll('.js-trigger');
        for (let i = 0; i < this.links.length; i++) {
            //console.log(i);
            this.links[i].addEventListener('click', (e) => {
                //console.log('clicked');
                e.preventDefault();

                // 対象のY軸の絶対座標を取得
                //const targetElem = this.links[i].getBoundingClientRect().top;
                let targetElemId = this.links[i].getAttribute('href').replace(/#/g, '');
                let isTargetElem = false;

                let targetElemY;
                let offsetY;
                let toScrollY;
                let HeaderElem;
                let noticeElem;
                let scrollBuffer = 0;

                //let HeaderAll = document.querySelector('.Header');
                //scrollBuffer = Math.round(HeaderAll.clientHeight);
                
                if (document.querySelectorAll('.Header-inner')[0]){
                  HeaderElem = document.querySelector('.Header-inner');
                  scrollBuffer += HeaderElem.clientHeight;
                }

                if (document.querySelectorAll('.Header-notice')[0]){
                  noticeElem = document.querySelector('.Header-notice');
                  scrollBuffer += noticeElem.clientHeight;
                }

               scrollBuffer = Math.round(scrollBuffer);
                //console.log('scrollBuffer=' + scrollBuffer);

                if (document.getElementById(targetElemId)) {
                    targetElemY = document.getElementById(targetElemId).getBoundingClientRect().top;
                    targetElemY = Math.round(targetElemY);
                    isTargetElem = true;

                    // 現在のスクロール量を取得
                    offsetY = window.pageYOffset;

                    // 対象までのスクロール量を算出
                    toScrollY = Math.round(targetElemY + offsetY - scrollBuffer);

                    console.log('scrollBuffer=' + scrollBuffer  + ',toScrollY=' + toScrollY + ',targetElemY=' + targetElemY + ', offsetY='+offsetY);


                    window.scroll({
                        top: toScrollY, // スクロール量の設定
                        behavior: 'smooth' // スクロール動作の設定
                    });

                }


                //analytics event
                // let eventLabel = targetElemId;
                // gtag( 'event','click', {
                //     'event_category': 'gloabl_menu',
                //     'event_label'   : eventLabel,
                //     'event_callback': function() {
                //         console.log('gtag event: ' + eventLabel);
                //     }
                // });


            });
        }
    }


}